import SOCIAL_EMBED_SERVICES from '../../../../public/app/plugins/ut-social-media-embed/js/embed_services.es6';
import SocialEmbed from './lib/init_social_embeds.es6';

let loadedEmbeds = [];

$.fn.initSocialEmbed = function() {
  this.each( function() {
    const $self = $( this );
    const id = $self.attr( 'id' );

    // make sure embeds are only loaded once
    if ( loadedEmbeds.indexOf( id ) === -1 ) {
      loadedEmbeds.push( id );
    } else {
      return true;
    }
    const embed = new SocialEmbed( $self, SOCIAL_EMBED_SERVICES );
    embed.show();
  } );
};

$( '.js-socialembed' ).initSocialEmbed();

$( document ).ready( function() {
  if ( document.getElementById( 'sme-remove-list' ) ) {
    const datenschutz = new SocialEmbed( $( '#sme-remove-list' ), SOCIAL_EMBED_SERVICES );
    datenschutz.showRemoveList();
  }
} );
